export const getDropDownValues = (data) => {
  let campaignsByProperties = [];
  data && data.map((e) => {
    let searchedCampaignsByID = campaignsByProperties.length > 0 && campaignsByProperties.find(ele => ele.id === e.propertyId);
    if (searchedCampaignsByID) {
      searchedCampaignsByID.list.push({
        id: e.id,
        value: e.title,
        createdAt: e.createdAt,
        active: e.active,
        friendsCount: e.friendsCount,
        residentsCount: e.residentsCount,
        leasedCount: e.leasedCount
      })
    } else {
      campaignsByProperties.push({
        id: e.propertyId,
        value: e.propertyName,
        list: [{
          id: e.id,
          value: e.title,
          createdAt: e.createdAt,
          active: e.active,
          friendsCount: e.friendsCount,
          residentsCount: e.residentsCount,
          leasedCount: e.leasedCount
        }]
      })
    }
  })
  return campaignsByProperties
}

export const getCampaignsByPropertyIdsSelected = (propertyIds, allCampaignsByProperties) => {
  let campaignsArray = [];
  for (var i = 0; i < allCampaignsByProperties.length; i++) {
    if (propertyIds.includes(allCampaignsByProperties[i].id)) {
      campaignsArray.push(allCampaignsByProperties[i])
    }
  }
  return campaignsArray
}